module.exports = __webpack_public_path__ + "img/61.f3d19ad8.png";